// EventStepTraining.tsx
import React, { useEffect, useState } from 'react';
import { EventDataMap } from '../../../types/EventTypes';

interface Props {
  onNext: (data: EventDataMap['training']) => void;
  onBack: () => void;
  initialData?: EventDataMap['training'];
}

const EventStepTraining: React.FC<Props> = ({
  onNext,
  onBack,
  initialData,
}) => {
  const [formData, setFormData] = useState<EventDataMap['training']>({
    trainingPlanId: '',
    notes: '',
  });

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    }
  }, [initialData]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onNext(formData);
  };

  return (
    <form onSubmit={handleSubmit} className='space-y-4'>
      <h2 className='text-xl font-bold'>Step 2: Training Session Info</h2>

      <label className='block'>
        <span className='text-sm font-medium'>Training Plan ID</span>
        <input
          type='text'
          name='trainingPlanId'
          value={formData.trainingPlanId}
          onChange={handleChange}
          placeholder='Enter or select saved plan ID'
          className='p-2 border rounded w-full'
        />
      </label>

      <label className='block'>
        <span className='text-sm font-medium'>Session Notes</span>
        <textarea
          name='notes'
          value={formData.notes}
          onChange={handleChange}
          placeholder='Any custom instructions or notes for the session'
          className='p-2 border rounded w-full'
        />
      </label>

      <div className='flex justify-between'>
        <button
          type='button'
          onClick={onBack}
          className='px-4 py-2 bg-gray-400 text-white rounded'
        >
          Back
        </button>
        <button
          type='submit'
          className='px-4 py-2 bg-blue-600 text-white rounded'
        >
          Save
        </button>
      </div>
    </form>
  );
};

export default EventStepTraining;
